module.exports = __webpack_public_path__ + "img/fan.bb189f77.png";